import perssist from './perssist'

export default [
  perssist(['auth'])
]